import CacheArrayCore from "./core-array.cache";

export default new class Step2ColsCache extends CacheArrayCore {
  constructor() {
    super('step2-cols');
  }

}();